import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 8 16",
  "content": "<symbol viewBox=\"0 0 8 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook\"><path d=\"M6.93 7.763H4.757v7.752H1.534V7.763H0V5.025h1.534V3.252C1.534 1.983 2.136 0 4.785 0l2.387.01v2.659H5.44c-.283 0-.684.14-.684.746v1.61h2.457L6.93 7.763z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol